import { render, staticRenderFns } from "./UserProfile.vue?vue&type=template&id=0d2d16ff"
import script from "./UserProfile.vue?vue&type=script&lang=js"
export * from "./UserProfile.vue?vue&type=script&lang=js"
import style0 from "./UserProfile.vue?vue&type=style&index=0&id=0d2d16ff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports